import * as GalleryViewStyled from '../../../../../components/Toolkit/Gallery/components/GalleryView/GalleryView.styled';
import { GalleryViewProps } from '../../../../../components/Toolkit/Gallery/components/GalleryView/GalleryView.typed';
import {
  Svg360OutlineIc,
  PlayCircleOutlineIc,
  PlayOutlineIc,
} from '@dsch/dd-icons';
import { CDN_STATIC_ASSETS } from '../../../../../utils';
import { accessibleOnClick } from '../../../../../utils/Accessibility';

const GalleryView = ({
  title,
  openGallery,
  photoCount,
  media,
  hasCarousel,
  mainGalleryMediaImage,
  mainGalleryMedia,
  galleryMedia,
  THUMBNAIL_360,
  setIsYoutubeReviewOpen,
  isDisabled = false,
  onMediaClick,
}: GalleryViewProps) => {
  const isClickable = !isDisabled && media && media.length > 0;
  const hasReviewVideo = Boolean(
    media && media.find((mediaItem) => mediaItem.hasReview),
  );

  return (
    <GalleryViewStyled.Wrapper
      isDisabled={isDisabled}
      isClickable={isClickable}
      hasWhiteBackground={media && media.length <= 1}
    >
      <GalleryViewStyled.MainWrapper
        hasCarousel={hasCarousel}
        {...accessibleOnClick(() => {
          isClickable && openGallery();
          onMediaClick(mainGalleryMedia.id);
        }, 'button')}
      >
        <GalleryViewStyled.ContainerImage simpleImage={!hasCarousel}>
          {mainGalleryMediaImage && (
            <source type="image/webp" srcSet={mainGalleryMediaImage} />
          )}
          <GalleryViewStyled.MainImage
            src={mainGalleryMediaImage}
            alt={hasCarousel ? `${title} - Image 1` : title}
            simpleImage={!hasCarousel}
            width={568}
            height={426}
          />
        </GalleryViewStyled.ContainerImage>

        {setIsYoutubeReviewOpen && hasReviewVideo && (
          <GalleryViewStyled.WatchReview
            {...accessibleOnClick(() => {
              isClickable &&
                setIsYoutubeReviewOpen &&
                setIsYoutubeReviewOpen(true);
            }, 'button')}
            data-tracking="watch-review"
          >
            <PlayOutlineIc width="16" height="16" />
            <span>Watch Review</span>
          </GalleryViewStyled.WatchReview>
        )}

        {mainGalleryMedia && mainGalleryMedia.isVideo && (
          <GalleryViewStyled.WatchVideo
            {...accessibleOnClick(() => {
              isClickable && openGallery();
            }, 'button')}
            data-tracking="watch-review"
          >
            <GalleryViewStyled.YouTubeIcon
              src={`${CDN_STATIC_ASSETS}/images/illustrations/youtube-icon.svg`}
            />
          </GalleryViewStyled.WatchVideo>
        )}
        {mainGalleryMedia && mainGalleryMedia.is360 && (
          <GalleryViewStyled.OverlayContent opacity={false}>
            <Svg360OutlineIc width="40" height="40" />
          </GalleryViewStyled.OverlayContent>
        )}
      </GalleryViewStyled.MainWrapper>
      {hasCarousel && (
        <GalleryViewStyled.ListWrapper>
          {galleryMedia &&
            galleryMedia.length > 0 &&
            galleryMedia.map((item, index) => {
              const altImage = `${title} - Image ${index + 2}`;

              if (index < 3) {
                if (index === 2 && item.isPhoto && media.length > 4) {
                  return (
                    <GalleryViewStyled.ListImage
                      key={index}
                      {...accessibleOnClick(() => {
                        isClickable && openGallery();
                        onMediaClick(mainGalleryMedia.id);
                      }, 'button')}
                      data-tracking="gallery-thumbnail-click"
                    >
                      {item.isPhoto && photoCount && (
                        <>
                          <GalleryViewStyled.OverlayContent opacity={true}>
                            <GalleryViewStyled.ImageCounter>
                              {`+${photoCount}`}
                            </GalleryViewStyled.ImageCounter>
                          </GalleryViewStyled.OverlayContent>
                          <GalleryViewStyled.OverlayImage
                            src={item.src}
                            alt={altImage}
                          />
                        </>
                      )}
                    </GalleryViewStyled.ListImage>
                  );
                }

                return (
                  <GalleryViewStyled.ListImage
                    {...accessibleOnClick(() => {
                      isClickable && openGallery();
                      onMediaClick(item.id);
                    }, 'button')}
                    key={index}
                    data-tracking="gallery-thumbnail-click"
                  >
                    {item.isVideo && (
                      <>
                        <GalleryViewStyled.OverlayContent opacity={true}>
                          <PlayCircleOutlineIc width="40" height="40" />
                        </GalleryViewStyled.OverlayContent>
                        <GalleryViewStyled.OverlayImage
                          src={item.src}
                          alt={altImage}
                        />
                      </>
                    )}
                    {item.is360 && (
                      <>
                        <GalleryViewStyled.OverlayContent opacity={true}>
                          <Svg360OutlineIc width="40" height="40" />
                        </GalleryViewStyled.OverlayContent>
                        <GalleryViewStyled.OverlayImage
                          src={THUMBNAIL_360}
                          alt={altImage}
                        />
                      </>
                    )}
                    {item.isPhoto && (
                      <>
                        <GalleryViewStyled.OverlayImage
                          src={item.src}
                          alt={altImage}
                        />
                      </>
                    )}
                  </GalleryViewStyled.ListImage>
                );
              }
            })}
        </GalleryViewStyled.ListWrapper>
      )}
    </GalleryViewStyled.Wrapper>
  );
};

export { GalleryView };
